import { Pagination, PaginationItem, PaginationProps } from '@mui/material';

interface OwnProps {
    getHref?: (page: number) => string;
    onChange: (page: number) => void;
}

type Props = Omit<PaginationProps, 'onChange'> & OwnProps;

const StyledPagination: FC<Props> = ({ getHref, onChange, ...props }) => {
    const _onChange = (evt, page) => {
        evt.preventDefault();
        onChange(page);
    };

    return (
        <Pagination
            onChange={_onChange}
            classes={{
                root: 'styled-pagination',
            }}
            color="primary"
            size="small"
            sx={{
                margin: '0.5rem',
            }}
            renderItem={(item) => (
                <PaginationItem
                    component="a"
                    href={typeof getHref === 'function' ? getHref(item.page) : null}
                    {...item}
                />
            )}
            {...props}
        />
    );
};

export default StyledPagination;
